<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-9">
        <div class="row">
          <h1>Manage Users</h1>
        </div>
        <div *ngIf="isAdmin" class="row add">
          <button
            themeColor="primary"
            size="medium"
            (click)="onAddUserModal()"
            kendoButton
          >
            Add User <span>+</span>
          </button>
        </div>
        <div class="row users align-items-center">
          <kendo-grid
            [kendoGridBinding]="gridView"
            kendoGridSelectBy="id"
            [pageSize]="20"
            [pageable]="true"
            [sortable]="true"
            [groupable]="false"
            [selectable]="false"
            [reorderable]="true"
            [resizable]="true"
            [columnMenu]="{ filter: false }"
          >
            <ng-template kendoGridToolbarTemplate>
              <input
                [style.width.px]="225"
                placeholder="Search"
                kendoTextBox
                (input)="onFilter($event)"
              />
              <button id="search" type="submit">
                <i class="k-icon k-font-icon k-i-search"></i>
              </button>
              <kendo-grid-spacer></kendo-grid-spacer>
            </ng-template>
            <kendo-grid-column [width]="125" field="name" title="Name">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.firstName"
                  >{{ dataItem.firstName }} {{ dataItem.lastName }}</span
                >
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="250" field="email" title="Email">
            </kendo-grid-column>
            <kendo-grid-column field="role" title="Role"> </kendo-grid-column>
            <kendo-grid-column [width]="100" field="status" title="Status">
              <ng-template kendoGridCellTemplate let-dataItem>
                Active
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdAt" title="Created">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.createdAt | date }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
              *ngIf="isAdmin"
              [sortable]="false"
              field="id"
              title=""
              [width]="100"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <button
                  themeColor="primary"
                  icon="edit"
                  (click)="editUser(dataItem)"
                  kendoButton
                ></button>
                <button
                  themeColor="primary"
                  fillMode="outline"
                  icon="trash"
                  id="trash"
                  (click)="deleteUser(dataItem)"
                  kendoButton
                ></button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>
</section>
